import {process} from "@progress/kendo-data-query";
import {GridColumn as Column} from "@progress/kendo-react-grid/dist/npm/GridColumn";
import {Grid, GridToolbar} from "@progress/kendo-react-grid";
import {useEffect, useState} from "react";
import useProjectStore from "../../stores/ProjectStore";
import useProjectTeamStore from "../../stores/ProjectTeamStore";
import useUserStore from "../../stores/UserStore";
import Waiting from "../waiting/Waiting";
import Confirm from "../general/Confirm";
import {Dialog, DialogActionsBar} from "@progress/kendo-react-dialogs";
import {DropDownList} from "@progress/kendo-react-dropdowns";
import {Button} from "@progress/kendo-react-buttons";

const initialDataState = {
    take: 100,
    skip: 0,
    sort:[
        {dir: "asc", field: "UserName" }
    ],
};

const ProjectTeamGrid = (props) => {

    const refSize = props.size
    const menuSize = props.menuSize

    const {selectedProject} = useProjectStore((state) => ({selectedProject: state.selectedItem}))

    const teamMembers = useProjectTeamStore(state => state.teamMembers)
    const isLoading = useProjectTeamStore(state => state.isLoading)
    const loadTeamForProject = useProjectTeamStore(state => state.loadTeamForProject)
    const addTeamMember = useProjectTeamStore(state => state.addTeamMember)
    const removeTeamMember = useProjectTeamStore(state => state.removeTeamMember)

    const users = useUserStore(state => state.storeData)
    const loadUsers = useUserStore(state => state.loadAll)

    const [dataState, setDataState] = useState(initialDataState);
    const [showAddDialog, setShowAddDialog] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [deletedItem, setDeletedItem] = useState(null);

    useEffect(() => {
        if (selectedProject?.ID) {
            loadTeamForProject(selectedProject.ID)
        }
    }, [selectedProject])

    useEffect(() => {
        if (users.length === 0) {
            loadUsers()
        }
    }, [])

    // Filter out users already in team
    const availableUsers = users.filter(user =>
        user.Status === 1 &&
        !teamMembers.some(member => member.UserID === user.ID)
    )

    const handleAddMember = () => {
        setSelectedUser(null)
        setShowAddDialog(true)
    }

    const handleConfirmAdd = async () => {
        if (selectedUser && selectedProject?.ID) {
            try {
                await addTeamMember(selectedProject.ID, selectedUser.ID)
                setShowAddDialog(false)
                setSelectedUser(null)
            } catch (error) {
                console.error("Error adding team member:", error)
            }
        }
    }

    const handleCancelAdd = () => {
        setShowAddDialog(false)
        setSelectedUser(null)
    }

    const handleRemoveMember = (dataItem) => {
        setDeletedItem(dataItem)
        setShowConfirmDelete(true)
    }

    const confirmRemove = () => {
        if (deletedItem) {
            removeTeamMember(deletedItem.ID)
        }
        setShowConfirmDelete(false)
        setDeletedItem(null)
    }

    const cancelRemove = () => {
        setShowConfirmDelete(false)
        setDeletedItem(null)
    }

    const CommandCell = (props) => {
        return (
            <td>
                <Button
                    themeColor="error"
                    size="small"
                    onClick={() => handleRemoveMember(props.dataItem)}
                >
                    Odebrat
                </Button>
            </td>
        )
    }

    const CountFooter = (props) => {
        const total = teamMembers.length
        return (
            <td colSpan={props.colSpan} style={props.style}>
                {total} {total === 1 ? 'clen' : (total < 5 ? 'clenove' : 'clenu')}
            </td>
        )
    }

    return(
        <>
            <Grid
                sortable={true}
                filterable={true}
                resizable={true}
                reorderable={true}
                size={"small"}
                style={{
                    height: "100%",
                    minHeight: 20,
                    width: refSize.width - menuSize,
                }}
                data={process(teamMembers || [], dataState)}
                {...dataState}
                total={(teamMembers || []).length}
                pageable={{
                    buttonCount: 4,
                    pageSizes: [10, 50, 100],
                }}
                onDataStateChange={(e) => setDataState(e.dataState)}
            >
                <GridToolbar>
                    <button
                        title="Pridat clena"
                        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                        onClick={handleAddMember}
                        disabled={!selectedProject}
                    >
                        Pridat clena tymu
                    </button>
                </GridToolbar>

                <Column field="UserName" title="Jmeno" width="250px" footerCell={CountFooter} />
                <Column field="UserNick" title="Nick" width="150px" />
                <Column field="UserEmail" title="Email" width="300px" />
                <Column
                    field="action"
                    title=" "
                    width="120px"
                    cell={CommandCell}
                    filterable={false}
                    sortable={false}
                />
            </Grid>

            {showAddDialog && (
                <Dialog title="Pridat clena tymu" onClose={handleCancelAdd} width={400}>
                    <div style={{padding: "20px"}}>
                        <label style={{display: "block", marginBottom: "10px"}}>
                            Vyberte uzivatele:
                        </label>
                        <DropDownList
                            data={availableUsers}
                            textField="Name"
                            dataItemKey="ID"
                            value={selectedUser}
                            onChange={(e) => setSelectedUser(e.value)}
                            style={{width: "100%"}}
                            filterable={true}
                            onFilterChange={(e) => {}}
                        />
                    </div>
                    <DialogActionsBar>
                        <Button onClick={handleCancelAdd}>Zrusit</Button>
                        <Button
                            themeColor="primary"
                            onClick={handleConfirmAdd}
                            disabled={!selectedUser}
                        >
                            Pridat
                        </Button>
                    </DialogActionsBar>
                </Dialog>
            )}

            {showConfirmDelete && (
                <Confirm
                    action={confirmRemove}
                    cancel={cancelRemove}
                    text={`Odebrat ${deletedItem?.UserName} z tymu?`}
                />
            )}

            {isLoading && <Waiting />}
        </>
    )
}

export default ProjectTeamGrid
